/**
 * Achievement badge images. 8 achievements → 5 provided artworks (reused where appropriate).
 * Drop additional PNGs into /public/assets/badges/ and extend this map.
 */
const BADGE_IMG = {
  first_beat:      "/assets/badges/drums.png",
  getting_started: "/assets/badges/book.png",
  perfect_week:    "/assets/badges/perfect_week.png",
  drummer:         "/assets/badges/drums.png",
  bookworm:        "/assets/badges/book.png",
  on_fire:         "/assets/badges/fire.png",
  consistent:      "/assets/badges/trophy.png",
  comeback:        "/assets/badges/star.png",
};

export default function BadgeImage({ code, size = 56, earned = true, testId }) {
  const src = BADGE_IMG[code];
  if (!src) return null;
  return (
    <img
      data-testid={testId || `badge-${code}`}
      src={src}
      alt=""
      draggable={false}
      style={{ width: size, height: size }}
      className={`select-none pointer-events-none ${earned ? "" : "grayscale opacity-40"}`}
    />
  );
}

export { BADGE_IMG };
